// ** Custom Menu Components
import VerticalNavLink from './VerticalNavLink'
import VerticalNavGroup from './VerticalNavGroup'
import VerticalNavSectionTitle from './VerticalNavSectionTitle'
import Box from '@mui/material/Box'

const resolveNavItemComponent = item => {
  if (item.sectionTitle) return VerticalNavSectionTitle
  if (item.children) return VerticalNavGroup

  return VerticalNavLink
}

const VerticalNavItems = props => {
  // ** Props
  const { verticalNavItems } = props

  const RenderMenuItems = verticalNavItems?.map((item, index) => {
    const TagName = resolveNavItemComponent(item)

    return <TagName {...props} key={index} item={item} />
  })

  // Separate logout item from other items
  const logoutItem = verticalNavItems?.find(item => item.title === 'Log Out')
  const otherItems = verticalNavItems?.filter(item => item.title !== 'Log Out')

  const RenderOtherItems = otherItems?.map((item, index) => {
    const TagName = resolveNavItemComponent(item)

    return <TagName {...props} key={index} item={item} />
  })

  const RenderLogoutItem = logoutItem ? (
    <VerticalNavLink {...props} item={logoutItem} />
  ) : null

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ flex: 1 }}>
        {RenderOtherItems}
      </Box>
      <Box sx={{ mt: 'auto', pt: 2 }}>
        {RenderLogoutItem}
      </Box>
    </Box>
  )
}

export default VerticalNavItems
